import { z } from "zod";
export const ZBreeamCriterionCheckInput = z.object({
    body: z
        .object({
        runAi: z.boolean().optional(),
        outputLanguage: z.enum(["NO", "EN"]).optional(),
    })
        .optional(),
    issueId: z.string().regex(/^[0-9a-fA-F]{24}$/),
    projectId: z.string().regex(/^[0-9a-fA-F]{24}$/),
});
export const ZBreeamCriterionCheckOutput = z.object({
    status: z.enum(["preview", "success"]),
    verdict: z.enum(["PASS", "PARTIAL", "FAIL", "UNCERTAIN"]),
    inputData: z.object({
        otherAttributeIText: z.string(),
        pdfFileCount: z.number(),
        pdfFiles: z.array(z.object({
            fileName: z.string(),
            blobName: z.string(),
            extractedTextLength: z.number(),
        })),
        imageFiles: z.array(z.object({
            fileName: z.string(),
            blobName: z.string(),
            description: z.string(),
            includedInAi: z.boolean(),
            missingDescription: z.boolean(),
        })),
        aiInput: z.object({
            outputLanguage: z.enum(["NO", "EN"]),
            tokenEstimate: z.object({
                inputTokens: z.number(),
                outputTokens: z.number(),
                totalTokens: z.number(),
                estimatedCostNok: z.number(),
                usdToNokRate: z.number(),
                inputUsdPer1MTokens: z.number(),
                outputUsdPer1MTokens: z.number(),
                pricingNote: z.string(),
            }),
            relevanceKeywords: z.array(z.string()),
            prompt: z.string(),
            documents: z.array(z.object({
                fileName: z.string(),
                selectedText: z.string(),
                selectedTextLength: z.number(),
                totalTextLength: z.number(),
                pages: z.array(z.object({
                    pageNumber: z.number(),
                    text: z.string(),
                    textLength: z.number(),
                    selected: z.boolean(),
                })),
            })),
            imageEvidence: z.array(z.object({
                fileName: z.string(),
                description: z.string(),
            })),
        }),
    }),
    summary: z.string(),
    analysis: z.array(z.string()),
    evidence: z.array(z.object({
        documentName: z.string(),
        page: z.number(),
        text: z.string(),
    })),
    gaps: z.array(z.string()),
});
